export const CASH_BOX_ACCOUNT_TYPE = "קופה" as const;
export const CASH_BOXES_PATH = "/cash-boxes";
export const CASH_BOXES_BREADCRUMB = { ledger: "כרטסות", list: "קופה" } as const;
export const CASH_BOXES_STRUCTURE_CRUMBS = {
  browse: "הגדרת מבנה דפדוף",
} as const;